import type { Review } from '@/scopes/products/user-reviews/types'
import { useUdsToken } from '@sunwebgroup/uds-ui/utils'
import useEmblaCarousel from 'embla-carousel-react'
import { UserReview } from '../UserReview'
import styles from './List.module.css'

interface ListProps {
  reviews?: Review[]
}

export function List({ reviews }: ListProps) {
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    breakpoints: {
      [`(min-width: ${useUdsToken<string>('primitives_breakpoint_m_min')}px)`]: { active: false },
    },
  })
  return (
    <div className={styles.sliderWrapper}>
      <div className={styles.slider} ref={emblaRef}>
        <div className={styles.wrapper}>{reviews?.map(review => <UserReview key={review.id} {...review} />)}</div>
      </div>
    </div>
  )
}
